
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/faq",
      function () {
        return require("private-next-pages/learn/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/faq"])
      });
    }
  